import cx from 'classnames'
import { Dropzone as BasicDropzone } from 'screens/Uploads/Dropzone/Dropzone'
import Styles from './Dropzone.module.scss'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Animation } from 'blaze-components/Animations/Animation'
import drafting from 'screens/BrandKits/components/BrandVoice/AddVoice/Processing/analyzing.json'
import { LoadingEllipses } from 'components/Wizards/Wizard/Form/SectionHeader'
import { Text } from 'blaze-ui/Text/Text'

const DragOverlay = ({ isActive }: { isActive: boolean }) => (
  <div className={cx(Styles.dragOverlay, { [Styles.dragActive]: isActive })}>
    <Heading level={5} color="var(--light-100)">
      Drop your files here
    </Heading>
  </div>
)

export const Dropzone = ({
  onUpload,
  isLoading,
  displayText,
  buttonText,
}: {
  onUpload: (files: File[]) => void
  isLoading: boolean
  displayText: string
  buttonText: string
}) => {
  if (isLoading) {
    return (
      <div className={Styles.dropzone}>
        <div className={Styles.uploading}>
          <Animation animationData={drafting} play={true} style={{ width: 85, height: 85 }} />
          <Heading level={5}>
            Uploading
            <LoadingEllipses />
          </Heading>
        </div>
      </div>
    )
  }

  return (
    <BasicDropzone
      accept={'image/*'}
      onDrop={async (files) => {
        onUpload(files)
      }}
      styles={Styles.dropzone}
      supportText=""
      buttonVariant="secondary"
      IconComponent={() => null}
      DragOverlayComponent={DragOverlay}
      buttonText={buttonText}
    >
      <div className={Styles.dropzoneContent}>
        <Text variant="secondary" color="var(--dark-80)">
          {displayText}
        </Text>
      </div>
    </BasicDropzone>
  )
}
